import React from 'react';
import { StarIcon } from '../../appearence/icons/star_icon';
import { useTranslation } from 'react-i18next';
import { Button } from '@chapche/ui';

const PreferencesListSelectIsDefault = ({ phrasesListManager }) => {
    const { i18n } = useTranslation();
    return (
        <Button variant="outline" className="gap-8" onClick={() => phrasesListManager.updatePreferenceIsWelcome(true)}>
            <StarIcon/>
            {i18n.t('app.page.preference.addInIsWelcome')}
        </Button>
    );
};

export default PreferencesListSelectIsDefault;
